@if (showCTABlockData()) {
  <div
    class="px-8"
    [ngClass]="{
      'bg-white !text-ss-brown': !showCTABlockData().darkBackground,
      'pt-16 md:pt-20 xl:pt-24': showCTABlockData().topPadding,
      'pb-16 md:pb-20 xl:pb-24': showCTABlockData().bottomPadding,
    }"
  >
    @if (showCTABlockData().upperText) {
      <div
        class="text-center md:px-16 lg:px-24 xl:px-32"
        [innerHTML]="showCTABlockData().upperText | safe: 'html'"
        [ssDirectus]="{
          collection: 'showCTABlock',
          item: showCTABlockData().id,
          fields: ['upperText'],
        }"
      ></div>
    }
    <ss-www-star
      [starLineWidth]="showCTABlockData().starLineWidth"
      [textAbove]="!!showCTABlockData().upperText"
      [textOrButtonsBelow]="
        !!showCTABlockData().lowerText || !!dynamicButtons().length
      "
    ></ss-www-star>
    @if (showCTABlockData().lowerText) {
      <div
        class="text-center md:px-16 lg:px-24 xl:px-32"
        [innerHTML]="showCTABlockData().lowerText | safe: 'html'"
        [ssDirectus]="{
          collection: 'showCTABlock',
          item: showCTABlockData().id,
          fields: ['lowerText'],
        }"
      ></div>
    }
    @if (dynamicButtons().length) {
      <div
        class="mx-auto"
        [ngClass]="{
          'grid md:grid-flow-col grid-flow-row auto-cols-fr justify-center align-center gap-6 w-fit':
            showCTABlockData().buttonEqualsWidth,
          'flex flex-col md:flex-row grow flex-wrap justify-center my-6 gap-4 max-w-4xl':
            !showCTABlockData().buttonEqualsWidth,
        }"
      >
        @for (button of dynamicButtons(); track trackButton($index, button)) {
          @if (button.url === 'SHOW_CALENDAR_MODAL') {
            <ss-button
              [buttonColor]="button.buttonColor"
              [buttonStyle]="button.buttonStyle"
              (click)="openCalendarModal()"
              (keydown.enter)="openCalendarModal()"
              class="flex-1 md:flex-initial w-full md:w-auto"
              >{{ button.text }}</ss-button
            >
          } @else {
            <ss-building-block-button-link
              [buttonLink]="button"
              class="flex-1 md:flex-initial w-full md:w-auto"
            ></ss-building-block-button-link>
          }
        }
      </div>
    }
  </div>
}

<!-- Calendar Modal -->
@if (showCalendarModal()) {
  <ss-modal
    [open]="showCalendarModal()"
    (closeClick)="closeCalendarModal()"
    [enableCloseOutside]="true"
    modalheight="720px"
    modalwidth="100%"
    maxWidth="672px"
    maxHeight="720px"
    class="show-cta-block-modal"
    [@modalAnimation]
  >
    <svg
      closeButton
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-4 h-4 text-white"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
    <div class="h-full">
      <ss-building-block-month-view-base
        [showCode]="showCTABlockData().show?.showCode || undefined"
      ></ss-building-block-month-view-base>
    </div>
  </ss-modal>
}
